module.exports = __webpack_public_path__ + "img/wb1.84a822a9.png";